import { createContext, ReactNode, useContext, useState } from 'react';

const STORAGE_KEY = 'routing-admin-tenant';

const storedTenant = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) ?? '';
  } catch {
    return '';
  }
};

const TenantContext = createContext<{ tenant: string; setTenant: (tenant: string) => void }>({
  tenant: 'default',
  setTenant: () => undefined
});

export const TenantProvider = ({
  children,
  initialTenant
}: {
  children: ReactNode;
  initialTenant?: string;
}) => {
  const [tenant, setTenantState] = useState(() => initialTenant ?? (storedTenant() || 'default'));

  const setTenant = (next: string) => {
    const value = next || 'default';
    setTenantState(value);
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch {
      /* per-browser convenience only */
    }
  };

  return <TenantContext.Provider value={{ tenant, setTenant }}>{children}</TenantContext.Provider>;
};

export const useTenant = () => useContext(TenantContext);
